import {useState, useEffect} from 'react'

// redux
import { useSelector } from "react-redux";

export default function useStoreUrl() {
    // states
    const [storeUrl, setStoreUrl] = useState("")

    // getting storeId
    const storeId = useSelector(state => state?.auth?.storeId)

    // setting store url
	useEffect(() => {
		setStoreUrl("/store/" + storeId)
	}, [storeId])

    return [storeUrl]
}